import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

const VALID_TABS = ['customers', 'transfers', 'alerts'];

const ComplianceDashboardOverview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const lastSegment = pathname.split('/').pop() ?? '';
  const activeKey = VALID_TABS.includes(lastSegment)
    ? lastSegment
    : 'customers';

  const tabs: TabsProps['items'] = [
    {
      key: 'customers',
      label: t('translation.customers'),
    },
    {
      key: 'transfers',
      label: t('translation.transfers'),
    },
    {
      key: 'alerts',
      label: t('translation.alerts'),
    },
  ];

  return (
    <>
      <Tabs
        activeKey={activeKey}
        items={tabs}
        onChange={(key) => navigate(key, { replace: true })}
      />
      <Outlet />
    </>
  );
};

export default ComplianceDashboardOverview;
